module.exports = __webpack_public_path__ + "img/television.cd6e41f0.png";